$(function() {
    var slider;
    var sliderFlag = false;
    var breakpoint = 800;
 
    $(window).on('load resize', function() {
        sliderSet();
    });
 
    function sliderSet() {
        var windowWidth = $(window).width();
        if (windowWidth <= breakpoint && !sliderFlag) {
            slider = $('#resale_slider').bxSlider({
	auto:false,
	responsive:true,
	infiniteLoop: false,
	pause:3000,
	speed:1000,
	pager:true,
	touchEnabled:true,
	moveSlides:1
	});
            sliderFlag = true;
        } else if (windowWidth > breakpoint && sliderFlag) {
            slider.destroySlider();
            sliderFlag = false;
        }
    }
});

$(function(){
  $(".over").mouseover(function(){
      $(this).children('img').attr("src",$(this).children("img").attr("src").replace(/^(.+)(\.[a-zA-Z]+)$/, "$1_on$2"))
  }).mouseout(function(){
    $(this).children('img').attr("src",$(this).children("img").attr("src").replace(/^(.+)_on(\.[a-zA-Z]+)$/, "$1$2"));
  })
});